import { createAction } from "typesafe-actions";
import type { ExportName } from "../../type";

export const setIntegrationModalState = createAction("@@si/manage-integration/toggle-modal/SET_MODAL_STATE")<boolean>();

export const setToggle = createAction("@@si/manage-integration/toggle-modal/SET_TOGGLE")<ExportName>();

export const setIsDisabledIntegrationModal = createAction(
    "@@si/manage-integration/toggle-modal/SET_DISABLED",
)<boolean>();

export const setIsMissingMandatoryFieldsModalOpen = createAction(
    "@@si/manage-integration/missing-mandatory-fields-modal/SET_MODAL_STATE",
)<boolean>();
